export const BUTTON_VARIABLE_LABEL = "Button Variable"

const getTemplateComponents = templateOrComponents => {
  if (Array.isArray(templateOrComponents)) {
    return templateOrComponents
  }

  return templateOrComponents?.components || []
}

export const getTemplateHeaderVar = templateOrComponents => {
  const components = getTemplateComponents(templateOrComponents)

  for (const component of components) {
    const headerExample = component?.example?.header_text?.[0]

    if (headerExample) {
      return headerExample
    }
  }

  return ""
}

export const getTemplateBodyVars = templateOrComponents => {
  const components = getTemplateComponents(templateOrComponents)

  for (const component of components) {
    const bodyExamples = component?.example?.body_text?.[0]

    if (Array.isArray(bodyExamples) && bodyExamples.length > 0) {
      return bodyExamples
    }
  }

  return []
}

export const getTemplateButtonVars = templateOrComponents => {
  const components = getTemplateComponents(templateOrComponents)
  const buttonVars = []

  components.forEach((component, componentIndex) => {
    if (component?.type !== "BUTTONS" || !Array.isArray(component?.buttons)) {
      return
    }

    component.buttons.forEach((button, buttonIndex) => {
      const buttonExample = Array.isArray(button?.example)
        ? button.example[0]
        : ""

      if (!buttonExample) {
        return
      }

      const variableIndex = buttonVars.length + 1

      buttonVars.push({
        key:
          variableIndex === 1
            ? "buttonVariable"
            : `buttonVariable${variableIndex}`,
        label: BUTTON_VARIABLE_LABEL,
        text: button?.text || "",
        type: button?.type || "",
        example: buttonExample,
        componentIndex,
        buttonIndex,
      })
    })
  })

  return buttonVars
}

export const serializeButtonVariables = (buttonVars, valueSource) => {
  const readValue = (buttonVar, index) => {
    if (Array.isArray(valueSource)) {
      return valueSource[index]
    }

    return valueSource?.[buttonVar.key]
  }

  return buttonVars
    .map((buttonVar, index) => {
      const value = readValue(buttonVar, index)

      if (value === undefined || value === null || value === "") {
        return null
      }

      return {
        key: buttonVar.key,
        label: buttonVar.label,
        text: buttonVar.text,
        type: buttonVar.type,
        value,
        buttonIndex: buttonVar.buttonIndex,
        componentIndex: buttonVar.componentIndex,
      }
    })
    .filter(Boolean)
}

export const appendButtonVariablesToFormData = (
  formData,
  buttonVars,
  valueSource
) => {
  const serializedButtonVariables = serializeButtonVariables(buttonVars, valueSource)

  serializedButtonVariables.forEach(buttonVar => {
    formData.append(buttonVar.key, buttonVar.value)
  })

  return serializedButtonVariables
}
